export const ROLES_CHANGED_HANDLER_ID = 'ROLES_CHANGED_HANDLER_ID';
export const USERS_CHANGED_HANDLER_ID = 'USERS_CHANGED_HANDLER_ID';
